var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"cursor-pointer font-bold",attrs:{"to":{ 
      name: 'mark-list', 
      params: {
        class_id: _vm.params.colDef.CellRendererParams.class_id,
        student_id: _vm.params.data.client_user_id,
        student_name: _vm.params.data.student_name,
        class_name: _vm.params.data.class_name,
        session_name: _vm.params.data.class_term,
        user_class_answer_master_id: _vm.params.data.id,
        edit_permission: _vm.params.colDef.CellRendererParams.permissions
      },
      query: {
        is_archived: _vm.params.colDef.CellRendererParams.is_archived
      }
    }}},[_vm._v("\n    Marks Entry\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }